import type { InjectionKey } from 'vue'
import type Vue from 'vue'

/**
 * Definción de providers globales para los componentes de Vue
 * usando Composition API
 */

export const ToastKey: InjectionKey<typeof Vue.$toast> = Symbol('toast')
export const VuexStoreKey: InjectionKey<(typeof import('@/store'))['default']> = Symbol('vuex-store')

type BreakpointManager = (typeof import('@core/utils/breakpoint'))['breakpointsMng']
export const BreakpointKey: InjectionKey<BreakpointManager> = Symbol('breakpoint-wite')
